import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import '../App.css';

function Education() {
    const { t } = useTranslation();

    return (
        <section id="education" style={{ padding: 'var(--section-spacing) 0', position: 'relative' }}>
            <Container>
                <motion.h2
                    className="section-title"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    {t('education')}
                </motion.h2>
                <Row className="justify-content-center">
                    <Col md={8}>
                        <motion.div
                            className="glass-card d-flex align-items-center flex-column flex-md-row gap-4"
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5 }}
                            whileHover={{ scale: 1.02 }}
                        >
                            <div style={{ flexShrink: 0 }}>
                                <img
                                    src="UCRLogo.jpg"
                                    alt="UCR Logo"
                                    style={{
                                        width: '120px',
                                        height: '120px',
                                        borderRadius: '12px',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                            <div className="text-center text-md-start">
                                <h3 style={{ fontSize: '1.8rem', marginBottom: '0.5rem' }}>{t('UCR')}</h3>
                                <p style={{
                                    fontSize: '1.2rem',
                                    color: 'var(--accent-primary)',
                                    fontWeight: '600',
                                    marginBottom: '0.5rem'
                                }}>
                                    {t('bs_cs')}
                                </p>
                                <p style={{ color: 'var(--text-secondary)' }}>
                                    2020 - 2024
                                </p>
                            </div>
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Education;
